import { GET_NOTIFICATION_SETTINGS, RESET_REDUX_STATE } from "../../redux/constants";

const initialState = {
  emailNotificationData: undefined,
};

const emailNotification = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_NOTIFICATION_SETTINGS:
      {
        return {
          emailNotificationData: payload,
        };
      }
      case RESET_REDUX_STATE: {
        return initialState
      }

    default:
      return state;
  }
};

export default emailNotification
